import { render } from "./Edit.vue?vue&type=template&id=1c621e50&scoped=true&lang=pug"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=1c621e50&lang=scss"
import "./Edit.vue?vue&type=style&index=1&id=1c621e50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c621e50"]])

export default __exports__